export const TEST_MODE_MANUAL_LOCATION_KEY = 'manual_delivery_entry';

export const TEST_MODE_DEFAULTS = {
  phone: '0501234567',
  seatNo: '12',
  row: 'A',
  stand: 'Main',
  floor: '1',
  room: 'Test Room',
  entrance: 'A',
  seatDetails: 'Test delivery details',
  deliveryNotes: 'Test order - no action needed',
};

export const STRIPE_TEST_PAYMENT_METHOD = 'pm_card_visa';
